export const getUser = (state) => state.user
export const getToken = (state) => state.token
export const getLogin = (state) => state.login
